module.exports = __webpack_public_path__ + "static/img/place-view-tabs02.9f1f9088.svg";